import PropTypes from 'prop-types';
import { DOCUMENT_ATTACHMENT_TYPE, PHOTO_ATTACHMENT_TYPE, OSS_URN_TYPE, DM_URN_TYPE } from '../attachment-types';

// eslint-disable-next-line import/prefer-default-export
export const attachmentAttributesType = PropTypes.shape({
  attachmentType: PropTypes.oneOf([DOCUMENT_ATTACHMENT_TYPE, PHOTO_ATTACHMENT_TYPE]),
  createdBy: PropTypes.string.isRequired,
  id: PropTypes.string,
  issueId: PropTypes.string.isRequired,
  markupMetadata: PropTypes.object,
  name: PropTypes.string.isRequired,
  resourceUrns: PropTypes.object,
  url: PropTypes.string,
  urn: PropTypes.string.isRequired,
  urnType: PropTypes.oneOf([DM_URN_TYPE, OSS_URN_TYPE]),
});
